import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, Row, Col, DatePicker, Select } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { CSVLink } from "react-csv";
import { franchiseOptions } from "../../constants/Customer";
const { Text } = Typography;
const { RangePicker } = DatePicker;

const FranchiseDirections = () => {
	const [loading, setLoading] = useState(true);
	const [inspectionList, setInspectionList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [franchise, setFranchise] = useState("57Concrete");
	const [plant, setPlant] = useState("");
	const [plants, setPlants] = useState([]);
	const refDownload = useRef();

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Direction",
			dataIndex: "direction",
			key: "direction",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Customer Direction",
			dataIndex: "customerDirection",
			key: "customerDirection",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "PSI",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Yards",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		if (startDate && endDate && franchise && plant) {
			getJobs();
		}
	}, [startDate, endDate, franchise, plant]);

	useEffect(() => {
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/options/logistics";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload
				.filter((i) => i.name !== "Laredo")
				.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
			const mission = list.find((i) => i.label === "Mission");
			setPlant(mission.value);
			setPlants(list);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getJobs = async () => {
		setLoading(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/${franchise}/directions?startDate=${start}&endDate=${end}&plant=${plant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					jobId: item.number,
					direction: item.shipAddress,
					customerDirection: item.customerShipAddress,
					date: dayjs(item.scheduledDate).format("MM/DD/YYYY HH:mm A"),
					customer: item.customer.name,
					plant: item.plant.name,
					yards: item.targetYD3,
					psi: item.psi ? item.psi : item.psiId ? item.psiId.psi : "-",
				});
			});
			setInspectionList(list);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangeFranchise = (value) => {
		setFranchise(value);
	};

	const onChangePlant = (value) => {
		setPlant(value);
	};

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => {
		return (
			<Row gutter={16}>
				<Col span={6}>
					<RangePicker
						defaultValue={[
							dayjs(startDate, "MM/DD/YYYY"),
							dayjs(endDate, "MM/DD/YYYY"),
						]}
						onChange={onRangeChange}
						format={"MM/DD/YYYY"}
						size="large"
						disabled={loading}
						allowClear={false}
						style={{ width: "100%" }}
					/>
				</Col>
				<Col span={6}>
					<Select
						showSearch
						placeholder={`Select franchise`}
						optionFilterProp="children"
						size="large"
						onChange={onChangeFranchise}
						filterOption={filterOption}
						options={franchiseOptions}
						disabled={loading}
						value={franchise}
						style={{
							width: "100%",
						}}
					/>
				</Col>
				<Col span={6}>
					<Select
						showSearch
						placeholder={`Select plant`}
						optionFilterProp="children"
						size="large"
						onChange={onChangePlant}
						filterOption={filterOption}
						options={plants}
						disabled={loading}
						value={plant}
						style={{
							width: "100%",
						}}
					/>
				</Col>
			</Row>
		);
		// return (
		// 	<CustomSearch
		// 		startDate={startDate}
		// 		endDate={endDate}
		// 		dateFormat={"MM/DD/YYYY"}
		// 		loading={loading}
		// 		onRangeChange={onRangeChange}
		// 		labelPicker={"franchise"}
		// 		optionsPicker={franchiseOptions}
		// 		onChangePicker={onChangeFranchise}
		// 		defaultValuePicker={franchise}
		// 		pickerWidth={"200px"}
		// 	/>
		// );
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"}>
				<CustomTable columns={columns} data={inspectionList} isScroll={false} />
			</Flex>
		);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={inspectionList}
					headers={headers()}
					filename={"57concrete-franchise-directions.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
							size="large"
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Franchises Report" description="Franchises Directions">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default FranchiseDirections;
